/**
 * mfaFactsApi.ts - AutoDoc "Configuration MFA actuelle".
 * Faits live depuis Microsoft Graph : Security Defaults, Conditional Access
 * (détail MFA) et registre MFA par utilisateur.
 */
import { apiFetch } from './apiClient';

export interface MfaCaPolicy {
  displayName:    string;
  state:          string;
  requiresMfa:    boolean;
  grantControls:  string;
  userScope:      string;
  clientAppTypes: string;
}

export interface MfaUser {
  userPrincipalName: string;
  isAdmin:           boolean;
  isMfaRegistered:   boolean;
  isSsprRegistered:  boolean;
  methods:           string;
}

export interface MfaFacts {
  securityDefaultsEnabled?: boolean | null;
  conditionalAccess?: {
    count: number; enabled: number; mfaEnforcing: number; items: MfaCaPolicy[];
  } | null;
  mfaRegistration?: {
    total: number; registered: number; percent: number;
    adminTotal: number; adminRegistered: number; listed: number; users: MfaUser[];
  } | null;
}

export interface MfaFactsResponse {
  success:   boolean;
  tenantId?: string;
  runAt?:    string;
  facts?:    MfaFacts;
  warnings?: { fact: string; code?: number; error?: string }[];
  error?:    string;
  hint?:     string;
}

export const mfaFactsApi = {
  get: () => apiFetch<MfaFactsResponse>('/mfa-facts'),
};
